"use client";

import { useCallback, useMemo } from "react";
import { useSearchParams } from "next/navigation";
import { usePathname, useRouter } from "@/i18n/navigation";
import { parseBoardFilters, serializeBoardFilters, type BoardFilters } from "./board-filters";

/**
 * Фильтры доски живут в адресе: ссылкой можно поделиться, «назад» возвращает прошлый набор.
 * replace, а не push — иначе каждый клик по чипу засоряет историю браузера.
 */
export function useBoardFilters(): [BoardFilters, (next: BoardFilters) => void] {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const query = searchParams.toString();

  const filters = useMemo(() => parseBoardFilters(new URLSearchParams(query)), [query]);

  const setFilters = useCallback(
    (next: BoardFilters) => {
      const qs = serializeBoardFilters(next).toString();
      router.replace(qs ? `${pathname}?${qs}` : pathname, { scroll: false });
    },
    [router, pathname],
  );

  return [filters, setFilters];
}
